var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user == null)?_c('div',[_c('button',{on:{"click":function($event){return _vm.signIn()}}},[_vm._v("G Suiteアカウントでログイン")])]):_c('div',[_c('span',[_vm._v(_vm._s(_vm.user.displayName)+" ("+_vm._s(_vm.user.email)+")")]),_vm._v(" "),_c('button',{on:{"click":function($event){return _vm.signOut()}}},[_vm._v("ログアウト")]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('app-main',{attrs:{"user":_vm.user}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6df2ea36","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 60
// module chunks = 1